export enum ServiceErrorOrigin {
    GET_SERVICES = 'GET_SERVICES',
    UPSERT_SERVICE = 'UPSERT_SERVICE',
    GET_SERVICE_CATEGORIES = 'GET_SERVICE_CATEGORIES',
    UPSERT_SERVICE_CATEGORY = 'UPSERT_SERVICE_CATEGORY',
    GET_SERVICE_BY_ID = 'GET_SERVICE_BY_ID',
}

export interface ServiceError {
    type: ServiceErrorOrigin,
    detail: any
}